import { defineStore } from "pinia";
import { useFiltersStore } from '@/state/pinia'
import { getPocketBaseUtils } from "../utils/pocketbaseUtils";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        userData: getPocketBaseUtils().getAuthenticatedUser(),
    }),
    getters: {
        loggedIn: (state) => !!state.userData,
        userId: (state) => state.userData ? state.userData.id : null,
        userName: (state) => state.userData ? state.userData.username : null,
        userDiscordId: (state) => state.userData ? state.userData.discordId : null,
        userDiscordAvatar: (state) => state.userData ? state.userData.discordAvatar : null,
        userGuilds: (state) => state.userData ? state.userData.discordGuilds : null,
    },
    actions: {
        async logInDiscord() {
            const authedUser = await getPocketBaseUtils().loginUser();
            const validatedUser = await this.validateGuild(authedUser);
            this.userData = validatedUser;
            return validatedUser;
        },
        validateUser() {
            // Refresh the local auth once per session
            if (sessionStorage.getItem("refreshedAuth") != "true") {
                getPocketBaseUtils().refreshAuth();
                sessionStorage.setItem("refreshedAuth", "true");
            }

            const validatedUser = getPocketBaseUtils().getAuthenticatedUser();

            if (validatedUser) {
                return validatedUser;
            } else {
                this.invalidateUser();
                throw new Error("Failed to authenticate user")
            }
        },
        async validateGuild(authedUser) {   
            if (authedUser.discordGuilds.length > 0) {
                return authedUser;
            } else {
                const notInGuildErrorMsg = `User ${getPocketBaseUtils().getAuthenticatedUser().username} is not part of a guild which uses this bot.`;
                this.invalidateUser();
                throw new Error(notInGuildErrorMsg);
            }
        },
        invalidateUser() {
            const filters = useFiltersStore();
            this.userData = null;
            filters.set = false;
            getPocketBaseUtils().logoutUser();
            return true;
        },
    },
})